"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueBaseContent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../hooks");
const utils_1 = require("../../utils");
const BlueBaseFilter_1 = require("../BlueBaseFilter");
/**
 * 🏡 BlueBaseContent
 * @param props
 */
const BlueBaseContent = (props) => {
    const { children, styles } = props;
    const BB = hooks_1.useBlueBase();
    const Navigation = hooks_1.useComponent('Navigation');
    const View = hooks_1.useComponent('View');
    const { theme } = hooks_1.useTheme();
    const intl = hooks_1.useIntl();
    return children ? (utils_1.renderChildrenWithProps(children, { BB })) : (react_1.default.createElement(View, { key: "bluebase-wrapper", style: styles.backdrop },
        react_1.default.createElement(react_native_1.StatusBar, { translucent: true, barStyle: theme.mode === 'dark' ? 'light-content' : 'dark-content' }),
        react_1.default.createElement(BlueBaseFilter_1.BlueBaseFilter, { filter: "bluebase.navigator.root", value: {}, args: { theme, BB, intl } }, (navigator) => react_1.default.createElement(Navigation, { navigator: navigator }))));
};
exports.BlueBaseContent = BlueBaseContent;
exports.BlueBaseContent.defaultStyles = (theme) => ({
    backdrop: {
        backgroundColor: theme.palette.background.default,
        flex: 1,
    },
});
